import { XmListType } from '@nkr/store/xm-tracking';

export const tabMap = [
    { id: XmListType.RequestedBy, link: 'by-your-center' },
    { id: XmListType.RequestedFrom, link: 'from-your-center' },
    { id: XmListType.History, link: 'history' },
    { id: XmListType.All, link: 'all' },
    { id: XmListType.MissingFxm, link: 'missing-fxm' },
    { id: XmListType.AdminPendingShipping, link: 'pending-shipping' },
    { id: XmListType.AdminShippedPendingDCenter, link: 'shipped-pending-d-center' },
    { id: XmListType.AdminShippedPendingRCenter, link: 'shipped-pending-r-center' },
    { id: XmListType.AdminCompleted, link: 'completed' },
    { id: XmListType.AdminCancelled, link: 'cancelled' },
];
